import styled from 'styled-components';
import { GlobalToken, Select, Table } from 'antd';

import { getTableCss } from '@/comp/pages/EnginePage/Engine/Common/styled';

const sensorsPriorityTableCss = `
  .sensors-priority-table {
    color: ${({ theme: { token } }) => token.colorTextSecondary};
    width: 100%;

    .ant-table {
      background-color: ${({ theme: { token } }) => token.colorBgContainer};
      .ant-table-thead > tr > th {
        background-color: ${({ theme: { token } }) => token.colorBgElevated};
      }

      td.ant-table-cell:first-child {
        background-color: ${({ theme: { token } }) => token.colorBgElevated};
        font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
      }

      .ant-table-tbody > tr > td.ant-table-cell-row-hover:first-child {
        background-color: ${({ theme: { token } }) => token.colorBgElevated};
      }
    }

    .table-cell {
      color: ${({ theme: { token } }) => token.colorTextTertiary};
      display: flex;
      flex-wrap: wrap;
    }
  }

  .sensors-priority-modal-table {
    width: 580px;
  }

  .chip-item {
    border-radius: 6px;
    background-color: ${({ theme: { token } }) => token.colorBgElevated};
    color: ${({ theme: { token } }) => token.colorText};
    padding: ${({ theme: { token } }) => token.paddingXXS}px;
    margin-right: ${({ theme: { token } }) => token.marginXXS}px;
    text-align: center;
    margin-bottom: ${({ theme: { token } }) => token.marginXXS}px;
  }
`;

export const FallbackOverviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: ${({ theme: { token } }) => token.marginSM}px ${({ theme: { token } }) => token.marginXXL}px
    ${({ theme: { token } }) => token.marginXXL}px ${({ theme: { token } }) => token.marginXXL}px;
  height: 100%;
`;

export const Card = styled.div`
  padding: ${({ theme: { token } }) => token.paddingMD}px ${({ theme: { token } }) => token.paddingLG}px
    ${({ theme: { token } }) => token.paddingXL}px ${({ theme: { token } }) => token.paddingLG}px;
  display: flex;
  flex-direction: column;
  margin-bottom: ${({ theme: { token } }) => token.marginXXL}px;

  ${({ theme: { token } }) => getTableCss(token)}

  ${sensorsPriorityTableCss}

  .icon {
    cursor: pointer;
  }

  .card-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: ${({ theme: { token } }) => token.fontSizeXL}px;
    margin-bottom: ${({ theme: { token } }) => token.marginMD}px;
    color: ${({ theme: { token } }) => token.colorText};
  }

  .card-body {
    gap: 24px;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(340px, 1fr));

    .card-item-container {
      &:not(:last-child) {
        margin-bottom: ${({ theme: { token } }) => token.margin}px;
        border-right: solid 0.5px ${({ theme: { token } }) => token.colorBorderSecondary};

        .card-item {
          padding-right: ${({ theme: { token } }) => token.paddingLG}px;
        }
      }
    }

    .card-item {
      display: flex;
      flex-direction: column;
      flex-grow: 1;

      .card-item-title {
        background-color: ${({ theme: { token } }) => token.colorBgElevated};
        color: ${({ theme: { token } }) => token.colorTextTertiary};
        font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
        padding: ${({ theme: { token } }) => `${token.paddingXS}px ${token.padding}px`};
        margin-bottom: ${({ theme: { token } }) => token.marginMD}px;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      .item-title {
        color: ${({ theme: { token } }) => token.colorText};
      }

      .item-subtitle {
        color: ${({ theme: { token } }) => token.colorTextSecondary};
        font-size: ${({ theme: { token } }) => token.fontSize}px;
      }
    }
  }

  .sensor-priority-info-message {
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    margin-bottom: ${({ theme: { token } }) => token.marginXL}px;
    margin-top: ${({ theme: { token } }) => token.marginXS}px;
  }

  .turn-off-engine-label {
    background-color: ${({ theme: { token } }) => token.colorError};
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
    font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
    border-radius: 14px;
    padding: ${({ theme: { token } }) => `${token.paddingXXS}px ${token.paddingLG}px`};
    align-self: center;
  }

  .fallback-by-flow-card-body {
    grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  }

  .compressors-group-card-item {
    flex-grow: 1;
  }

  .compressors {
    display: flex;
    flex-wrap: wrap;
    gap: ${({ theme: { token } }) => token.marginXS}px;
    align-items: center;
  }

  .on-failure-of-label {
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
    margin-right: ${({ theme: { token } }) => token.marginSM}px;
    color: ${({ theme: { token } }) => token.colorText};
  }

  .uppercase {
    text-transform: uppercase;
  }

  .fallback-behaviour {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: ${({ theme: { token } }) => token.marginXL}px;

    .fallback-rules {
      display: flex;
      align-items: center;

      & > :first-child {
        margin-right: ${({ theme: { token } }) => token.marginXS}px;
      }
    }

    & > div:not(:last-child) {
      margin-right: 0;
      margin-bottom: ${({ theme: { token } }) => token.marginXL}px;
    }
  }
`;

export const SensorsPriorityModalContentContainer = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  flex-direction: column;

  .sensors-fallback {
    font-size: ${({ theme: { token } }) => token.fontSizeXL}px;
    color: ${({ theme: { token } }) => token.colorText};
    margin-bottom: ${({ theme: { token } }) => token.marginXS}px;
  }

  ${sensorsPriorityTableCss}

  .sensors-priority-table {
    color: ${({ theme: { token } }) => token.colorTextTertiary};
    .ant-table {
      background-color: ${({ theme: { token } }) => token.colorBgContainer};

      .ant-table-tbody > tr > td.ant-table-cell-row-hover:not(:first-child) {
        background-color: ${({ theme: { token } }) => token.colorBgContainer};
      }
    }
  }

  .default-behaviour {
    border: 0.5px solid ${({ theme: { token } }) => token.colorBorder};
    border-radius: 2px;
    padding: ${({ theme: { token } }) =>
      `${token.paddingXS}px ${token.paddingSM}px ${token.paddingSM}px ${token.paddingSM}px`};
    margin-top: ${({ theme: { token } }) => token.marginXXL}px;

    .default-behaviour-label {
      font-size: ${({ theme: { token } }) => token.fontSize}px;
      font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
      margin-bottom: ${({ theme: { token } }) => token.marginXXS}px;
      color: ${({ theme: { token } }) => token.colorText};
    }

    .default-behaviour-radio-group {
      display: flex;
      height: 27px;

      .ant-select {
        margin-right: ${({ theme: { token } }) => token.marginMD}px;
        width: 110px;
      }

      > .ant-radio-wrapper {
        display: inline-flex;
        align-items: center;

        > span:last-child {
          padding-top: ${({ theme: { token } }) => token.paddingXXS}px;
        }
      }

      .rule-generator-button {
        margin-right: ${({ theme: { token } }) => token.marginMD}px;
      }
    }
  }

  .bottom-buttons {
    display: flex;
    justify-content: flex-end;
    gap: 16px;
    margin-top: ${({ theme: { token } }) => token.marginXXL}px;
  }
`;

export const ScenarioModalContentContainer = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  flex-direction: column;
  width: 100%;

  .add-scenario-button {
    align-self: flex-end;
  }

  .compressors-multiselect {
    width: 100%;
  }

  .edit-scenarios-title {
    font-size: ${({ theme: { token } }) => token.fontSizeXL}px;
    color: ${({ theme: { token } }) => token.colorText};
    margin-bottom: ${({ theme: { token } }) => token.marginXS}px;
  }

  .bottom-buttons {
    display: flex;
    justify-content: flex-end;
    gap: 16px;
    margin-top: ${({ theme: { token } }) => token.marginXXL}px;
  }

  .scenarios {
    display: flex;
    flex-direction: column;
    overflow: auto;
    flex-grow: 1;

    .scenario {
      display: flex;
      flex-direction: column;
      margin-bottom: ${({ theme: { token } }) => token.margin}px;

      .scenario-name-container {
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: ${({ theme: { token } }) => token.colorBgElevated};
        border-bottom: 2px solid ${({ theme: { token } }) => token.colorBorder};
        height: 40px;
        padding: 0 ${({ theme: { token } }) => token.paddingSM}px;

        .scenario-name {
          display: flex;
          flex-grow: 1;
          align-items: center;
        }

        .arrows {
          display: flex;
          align-items: center;
          margin-left: ${({ theme: { token } }) => token.marginXS}px;

          .arrow {
            width: 14px;
            cursor: pointer;
            margin-right: ${({ theme: { token } }) => token.marginXXS}px;
          }

          .low-opacity {
            opacity: 0.25;
            cursor: default;
          }

          .transform-down {
            transform: rotate(180deg);
          }
        }
      }

      .scenario-name-label {
        color: ${({ theme: { token } }) => token.colorPrimary};
        font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
        width: 100%;
      }

      .flex-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: ${({ theme: { token } }) => token.padding}px;

        .flex-column {
          display: flex;
          flex-direction: column;
        }

        .on-failure-off-label {
          font-size: ${({ theme: { token } }) => token.fontSize}px;
          font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
          color: ${({ theme: { token } }) => token.colorText};
          flex-shrink: 0;
          margin-right: ${({ theme: { token } }) => token.marginSM}px;
        }

        .ant-select-selection-overflow {
          max-width: 96%;
        }
      }
    }

    .fallback-behaviour-radio-group {
      display: flex;
      flex-direction: column;
      margin: 0 ${({ theme: { token } }) => token.marginSM}px;

      > label.ant-radio-wrapper {
        margin-top: ${({ theme: { token } }) => token.marginMD}px;

        > span:last-child {
          padding-top: ${({ theme: { token } }) => token.paddingXXS}px;
        }
      }

      .flow-range-name {
        font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
        color: ${({ theme: { token } }) => token.colorBorder};
        margin-left: ${({ theme: { token } }) => token.marginXL}px;
        margin-top: ${({ theme: { token } }) => token.marginXS}px;
      }

      .rule-container {
        border: 0.5px solid ${({ theme: { token } }) => token.colorBorder};
        border-radius: 2px;
        padding: ${({ theme: { token } }) => token.paddingXS}px;
        margin-top: ${({ theme: { token } }) => token.marginXXS}px;

        .rule-radio-group {
          display: flex;
          height: 27px;
          align-items: center;

          .ant-select {
            width: 110px;
            margin-right: ${({ theme: { token } }) => token.marginMD}px;
          }

          > .ant-radio-wrapper {
            display: inline-flex;
            align-items: center;

            > span:last-child {
              padding-top: ${({ theme: { token } }) => token.paddingXXS}px;
            }
          }
        }
      }
    }
  }
`;

export const MainContainerForFallbackTwoPointO = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: transparent;
  .search-filter-section {
    padding: ${({ theme: { token } }) => token.padding}px;
    background: transparent;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .search-filter-row {
    display: flex;
    align-items: center;
    gap: 12px;
  }
  .search-suffix {
    display: flex;
    align-items: center;
    padding-left: ${({ theme: { token } }) => token.paddingXS}px;
    margin-left: ${({ theme: { token } }) => token.marginXS}px;
    border-left: 1px solid ${({ theme: { token } }) => token.colorBorder};
    height: 140%;
    cursor: pointer;
  }
  .search-icon {
    color: ${({ theme: { token } }) => token.colorTextSecondary};
  }
  .fallback-count-fallback-two-point-o {
    color: ${({ theme: { token } }) => token.currentColor};
    font-size: ${({ theme: { token } }) => token.fontSize}px;
    padding-top: ${({ theme: { token } }) => token.marginSM}px;
  }
  .applied-filters-container {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    flex: 1;
  }
  .new-fallback-button-container {
    display: flex;
    gap: 10px;
    justify-content: center;
  }
  .content-section-fallback-two-point-o {
    display: flex;
    flex: 1;
    background: transparent;
    align-items: flex-start;
    padding-top: ${({ theme: { token } }) => token.paddingSM}px;
  }
  .left-panel-fallback-two-point-o {
    width: 320px;
    background: transparent;
    display: flex;
    flex-direction: column;
    height: calc(100vh - 120px);
    overflow: hidden;
  }
  .fallback-list-container-fallback-two-point-o {
    flex: 1;
    overflow-y: auto;
    background: transparent;
    min-height: 0;
  }
  .list-item-content-fallback-two-point-o {
    flex: 1;
  }
  .description-text-fallback-two-point-o {
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    color: ${({ theme: { token } }) => token.colorTextSecondary};
    line-height: 1.4;
    margin-top: ${({ theme: { token } }) => token.marginXS}px;

    .logical-operator {
      color: ${({ theme: { token } }) => token.colorPrimary};
      font-weight: 500;
    }

    .compressor-names {
      color: ${({ theme: { token } }) => token.colorWarning};
      font-weight: 600;
    }
  }
  .list-item-title {
    color: ${({ theme: { token } }) => token.colorText};
    font-weight: 500;
  }
  .right-panel-fallback-two-point-o {
    flex: 1;
    background: transparent;
    display: flex;
    flex-direction: column;
    height: calc(100vh - 120px);
    overflow: hidden;
    gap: ${({ theme: { token } }) => token.margin}px;
  }
  .container-compressor-dropdown-fallback-two-point-o {
    padding: ${({ theme: { token } }) => token.padding}px;
    background: ${({ theme: { token } }) => token.colorBgTextHover};
    color: ${({ theme: { token } }) => token.colorText};
    border-radius: 8px;
    margin: ${({ theme: { token } }) => token.margin}px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    border: 1px solid ${({ theme: { token } }) => token.colorBorderSecondary};
  }
  .details-container-fallback-two-point-o {
    padding: ${({ theme: { token } }) => token.padding}px;
    background: ${({ theme: { token } }) => token.colorBgTextHover};
    color: ${({ theme: { token } }) => token.colorText};
    border-radius: 8px;
    margin: 0 ${({ theme: { token } }) => token.margin}px ${({ theme: { token } }) => token.margin}px
      ${({ theme: { token } }) => token.margin}px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    border: 1px solid ${({ theme: { token } }) => token.colorBorderSecondary};
    overflow-y: auto;
  }
  .details-header-fallback-two-point-o {
    margin-bottom: ${({ theme: { token } }) => token.marginSM}px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }
  .details-content-fallback-two-point-o {
    flex: 1;
  }
  .details-title-fallback-two-point-o {
    &.ant-typography {
      color: ${({ theme: { token } }) => token.colorPrimary} !important;
      margin-bottom: ${({ theme: { token } }) => token.marginSM}px !important;
      font-size: ${({ theme: { token } }) => token.fontSizeXL}px !important;
      font-weight: ${({ theme: { token } }) => token.fontWeightStrong} !important;
    }
  }
  .scenario-description-fallback-two-point-o {
    color: ${({ theme: { token } }) => token.colorText};
    font-size: ${({ theme: { token } }) => token.fontSize}px;
    line-height: 1.5;
    margin-bottom: ${({ theme: { token } }) => token.marginSM}px;

    .logical-operator {
      color: ${({ theme: { token } }) => token.colorPrimary};
      font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
    }

    .compressor-names {
      color: ${({ theme: { token } }) => token.colorTextTertiary};
      font-weight: 600;
    }
  }
  .scenario-label-fallback-two-point-o {
    color: ${({ theme: { token } }) => token.colorTextPrimary};
  }
  .scenario-divider-fallback-two-point-o {
    border-bottom: 2px solid ${({ theme: { token } }) => token.colorBorderSecondary};
    margin-top: 0;
    margin-bottom: ${({ theme: { token } }) => token.margin}px;
    width: 100%;
    position: relative;
    left: 0;
  }
  .action-buttons-container-fallback-two-point-o {
    display: flex;
    gap: 10px;
    justify-content: flex-end;
  }

  .applied-filter-tag-fallback-two-point-o {
    background: ${({ theme: { token } }) => token.colorBgElevated};
    border: 1px solid ${({ theme: { token } }) => token.colorBorderSecondary};
    color: ${({ theme: { token } }) => token.colorText};
    border-radius: 4px;
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    padding: ${({ theme: { token } }) => token.paddingXXS}px ${({ theme: { token } }) => token.paddingSM}px;
    margin-top: ${({ theme: { token } }) => token.marginXS}px;
  }

  .view-button-fallback-two-point-o {
    color: ${({ theme: { token } }) => token.colorPrimary};
  }

  .scenario-label-fallback-two-point-o {
    color: ${({ theme: { token } }) => token.colorTextPrimary};
    margin-bottom: ${({ theme: { token } }) => token.marginSM}px;
  }

  .active-badge-fallback-two-point-o {
    background: ${({ theme: { token } }) => token.colorWarningBg};
    color: ${({ theme: { token } }) => token.colorWarningText};
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    padding: ${({ theme: { token } }) => token.paddingXXS}px ${({ theme: { token } }) => token.paddingSM}px;
    border: none;
    line-height: 1.4;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    white-space: nowrap;

    .icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 12px;
      height: 12px;
      border: 1.5px solid ${({ theme: { token } }) => token.colorWarningText};
      border-radius: 50%;
      font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
      font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
      color: ${({ theme: { token } }) => token.colorWarningText};
      line-height: 1;
      padding: ${({ theme: { token } }) => token.paddingXXS}px;
    }
  }

  .filter-icon-fallback-two-point-o {
    display: flex;
    flex-direction: column;
    gap: 6px;
    color: inherit;

    .line {
      position: relative;
      height: 2px;
      background: currentColor;
      border-radius: 2px;
    }

    .line:first-child {
      width: 20px;
    }
    .line:first-child::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 4px;
      transform: translateY(-50%);
      width: 7px;
      height: 7px;
      border: 2px solid currentColor;
      border-radius: 50%;
      background: transparent;
    }

    .line:last-child {
      width: 20px;
    }
    .line:last-child::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 12px;
      transform: translateY(-50%);
      width: 7px;
      height: 7px;
      border: 2px solid currentColor;
      border-radius: 50%;
      background: transparent;
    }
  }

  .filter-button-fallback-two-point-o {
    &.ant-btn {
      background: transparent;
      border: 1px solid ${({ theme: { token } }) => token.colorBorder};
      color: ${({ theme: { token } }) => token.colorText};
      border-radius: 6px;
      white-space: nowrap;
      display: flex;
      align-items: center;
      gap: 6px;
      height: 32px;
      padding: ${({ theme: { token } }) => token.paddingXXS}px ${({ theme: { token } }) => token.paddingSM}px;

      &:hover {
        background: ${({ theme: { token } }) => token.colorTextHover};
        border-color: ${({ theme: { token } }) => token.colorTextHover};
        color: ${({ theme: { token } }) => token.colorTextHover};
      }

      .anticon {
        font-size: 24px;
      }
    }
  }

  .input-fallback-two-point-o {
    &.ant-input-affix-wrapper {
      background: transparent;
      border: 0.5px solid ${({ theme: { token } }) => token.colorBorder};
      border-radius: 6px;
      width: 200px;

      .ant-input {
        background: transparent;
        color: ${({ theme: { token } }) => token.colorText};

        &::placeholder {
          color: ${({ theme: { token } }) => token.colorTextDisabled};
        }
      }

      .ant-input-prefix {
        color: ${({ theme: { token } }) => token.colorTextSecondary};
      }
    }
  }
  .compressor-dropdown-fallback-two-point-o {
    &.ant-select {
      min-width: 300px;

      .ant-select-selector {
        background: transparent;
        border: 0.5px solid ${({ theme: { token } }) => token.colorBorder};
        border-radius: 6px;
      }
    }
  }

  .container-compressor-dropdown-fallback-two-point-o {
    padding: ${({ theme: { token } }) => token.padding}px;
    background: ${({ theme: { token } }) => token.colorBgTextHover};
    color: ${({ theme: { token } }) => token.colorText};
    border-radius: 8px;
    margin: 0 ${({ theme: { token } }) => token.margin}px 0 ${({ theme: { token } }) => token.margin}px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    border: 1px solid ${({ theme: { token } }) => token.colorBorderSecondary};
    overflow-y: auto;
  }

  .list-item-fallback-two-point-o {
    &.ant-list-item {
      cursor: pointer;
      padding: ${({ theme: { token } }) => token.paddingSM}px ${({ theme: { token } }) => token.padding}px;
      border-bottom: 1px solid ${({ theme: { token } }) => token.colorBorderSecondary};
      background: transparent;
      border-left: 3px solid transparent;

      &:hover {
        background: ${({ theme: { token } }) => token.colorBgTextHover};
      }

      &.active {
        background: ${({ theme: { token } }) => token.colorBgElevated};
        border-left: 3px solid ${({ theme: { token } }) => token.colorPrimary};
      }

      .ant-list-item-meta-title {
        color: ${({ theme: { token } }) => token.colorText};
      }

      .ant-list-item-meta-description {
        color: ${({ theme: { token } }) => token.colorTextSecondary};
      }
    }
  }
`;

export const StyledTable = styled(Table)`
  .ant-table {
    background: ${({ theme: { token } }) => token.colorBgTextHover};

    .ant-table-thead > tr > th {
      background: ${({ theme: { token } }) => token.colorBgElevated};
      color: ${({ theme: { token } }) => token.colorText};
      border-bottom: 1px solid ${({ theme: { token } }) => token.colorBorderSecondary};
      border-right: 1px solid ${({ theme: { token } }) => token.colorBorderSecondary};
      padding: ${({ theme: { token } }) => token.paddingMD}px ${({ theme: { token } }) => token.paddingMD}px;
    }

    .ant-table-thead > tr > th:last-child {
      border-right: none !important;
    }

    .ant-table-tbody > tr > td {
      background: ${({ theme: { token } }) => token.colorBgContainer};
      color: ${({ theme: { token } }) => token.colorText};
      border-bottom: 1px solid ${({ theme: { token } }) => token.colorBorderSecondary};
      border-right: none !important;
      padding: ${({ theme: { token } }) => token.paddingMD}px ${({ theme: { token } }) => token.paddingMD}px;
    }

    .ant-table-tbody > tr:hover > td {
      background: ${({ theme: { token } }) => token.colorBgTextHover};
    }
  }
`;

export const WhiteSelect = styled(Select)`
  &.ant-select {
    color: ${({ theme: { token } }) => token.colorText};
  }

  .ant-select-selector {
    color: ${({ theme: { token } }) => token.colorText};
  }

  .ant-select-selection-placeholder {
    color: ${({ theme: { token } }) => token.colorText} !important;
    opacity: 1;
  }

  .ant-select-dropdown {
    color: ${({ theme: { token } }) => token.colorText};
  }

  .ant-select-item-option-content {
    color: ${({ theme: { token } }) => token.colorText};
  }
`;

export const MainContainerForAddFallback = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: transparent;
  .header-buttons {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 8px;
    padding: ${({ theme: { token } }) => token.padding}px;
    width: 100%;
  }
  .content-section {
    display: flex;
    flex: 1;
    background: transparent;
    align-items: flex-start;
    padding-top: ${({ theme: { token } }) => token.paddingSM}px;
  }
  .left-panel {
    width: 320px;
    background: transparent;
    display: flex;
    flex-direction: column;
    height: calc(100vh - 120px);
    overflow: hidden;
    border: none;
    padding: ${({ theme: { token } }) => token.padding}px;
  }
  .filter-header {
    padding: 0 ${({ theme: { token } }) => token.padding}px ${({ theme: { token } }) => token.padding}px;
    border: none;
    background: transparent;
  }
  .filter-subtitle {
    color: ${({ theme: { token } }) => token.colorTextSecondary};
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
  }
  .filter-title {
    &.ant-typography {
      color: ${({ theme: { token } }) => token.colorText} !important;
      margin-bottom: 4px !important;
      font-size: ${({ theme: { token } }) => token.fontSizeLG}px !important;
      font-weight: ${({ theme: { token } }) => token.fontWeightStrong} !important;
    }
  }

  .filter-content {
    flex: 1;
    padding: 0 ${({ theme: { token } }) => token.padding}px;
    overflow-y: auto;
    background: transparent;
    border: none;
  }
  .full-width-space {
    width: 100%;
    direction: vertical;
  }
  .filter-condition-container {
    margin-bottom: ${({ theme: { token } }) => token.margin}px;
    display: flex;
    align-items: flex-start;
    gap: 8px;
  }
  .filter-condition-content {
    flex: 1;
  }
  .and-condition-container {
    display: flex;
    align-items: center;
    margin-bottom: 4px;
  }
  .and-label {
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
    margin-right: ${({ theme: { token } }) => token.marginSM}px;
  }
  .full-width-select {
    width: 100%;
  }
  .compressor-width-select {
    width: 100%;
    margin-top: ${({ theme: { token } }) => token.marginSM}px;
  }
  .add-condition-button {
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    color: ${({ theme: { token } }) => token.colorPrimary};
    cursor: pointer;
    margin-top: ${({ theme: { token } }) => token.marginSM}px;

    &:hover {
      text-decoration: underline;
    }
  }
  .right-panel {
    flex: 1;
    background: transparent;
    display: flex;
    flex-direction: column;
    height: calc(100vh - 120px);
    overflow: hidden;
    padding: ${({ theme: { token } }) => token.padding}px;
    box-sizing: border-box;
  }
  .details-container {
    display: inline-block;
    padding: ${({ theme: { token } }) => token.padding}px;
    background: ${({ theme: { token } }) => token.colorBgTextHover};
    color: ${({ theme: { token } }) => token.colorText};
    border-radius: 0;
    margin: ${({ theme: { token } }) => token.margin}px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    border: none;
  }
  .details-header {
    margin-bottom: ${({ theme: { token } }) => token.marginLG}px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }
  .details-content {
    flex: 1;
  }
  .details-title {
    color: ${({ theme: { token } }) => token.colorPrimary} !important;
    margin-bottom: ${({ theme: { token } }) => token.marginSM}px !important;
    font-size: ${({ theme: { token } }) => token.fontSizeLG}px !important;
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong} !important;
    level: 4;
  }
  .scenario-description {
    color: ${({ theme: { token } }) => token.colorTextSecondary};
    font-size: ${({ theme: { token } }) => token.fontSize}px;
    line-height: 1.5;
    margin-bottom: ${({ theme: { token } }) => token.marginSM}px;

    .logical-operator {
      color: ${({ theme: { token } }) => token.colorPrimary};
      font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
    }

    .compressor-names {
      color: ${({ theme: { token } }) => token.colorWarning};
      font-weight: 600;
    }
  }
  .applied-filters-container {
    margin-bottom: ${({ theme: { token } }) => token.margin}px;
  }
  .applied-filters-label {
    margin-bottom: ${({ theme: { token } }) => token.marginSM}px;
    display: block;
  }
  .applied-filters-tag {
    background: ${({ theme: { token } }) => token.colorBgElevated};
    border: 1px solid ${({ theme: { token } }) => token.colorBorderSecondary};
    color: ${({ theme: { token } }) => token.colorPrimary};
    border-radius: 4px;
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    padding: ${({ theme: { token } }) => token.paddingXXS}px ${({ theme: { token } }) => token.paddingSM}px;
  }
`;

export const ContentWrapperForCreateNewFallBackpopUpModal = styled.div`
  text-align: center;
  max-width: 480px;
  width: 100%;
  margin: 0 auto;
  .modal-title {
    font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
    margin-bottom: ${({ theme: { token } }) => token.marginSM}px;
    text-align: left;
  }
  .modal-subtitle {
    display: block;
    font-size: ${({ theme: { token } }) => token.fontSize}px;
    margin-bottom: ${({ theme: { token } }) => token.marginLG}px;
    text-align: left;
  }
  .filter-content {
    text-align: left;
    margin-bottom: ${({ theme: { token } }) => token.marginLG}px;
  }
  .full-width-space {
    width: 100%;
    direction: vertical;
  }
  .filter-condition-container {
    margin-bottom: ${({ theme: { token } }) => token.margin}px;
    display: flex;
    align-items: flex-start;
    gap: 8px;
  }
  .filter-condition-content {
    flex: 1;
  }
  .and-condition-container {
    display: flex;
    align-items: center;
    margin-bottom: 4px;
  }
  .and-label {
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
    margin-right: ${({ theme: { token } }) => token.marginSM}px;
    color: ${({ theme: { token } }) => token.colorText};
  }
  .full-width-select {
    width: 100%;
  }
  .compressor-width-select {
    width: 100%;
    margin-top: ${({ theme: { token } }) => token.marginSM}px;
  }
  .add-condition-button {
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    color: ${({ theme: { token } }) => token.colorPrimary};
    cursor: pointer;
    margin-top: ${({ theme: { token } }) => token.marginSM}px;

    &:hover {
      text-decoration: underline;
    }
  }
  .applied-filters-container {
    margin-bottom: ${({ theme: { token } }) => token.margin}px;
  }
  .applied-filters-label {
    margin-bottom: ${({ theme: { token } }) => token.marginSM}px;
    display: block;
  }
  .applied-filters-tag {
    background: ${({ theme: { token } }) => token.colorBgElevated};
    border: 1px solid ${({ theme: { token } }) => token.colorBorderSecondary};
    color: ${({ theme: { token } }) => token.colorPrimary};
    border-radius: 4px;
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    padding: ${({ theme: { token } }) => token.paddingXXS}px ${({ theme: { token } }) => token.paddingSM}px;
  }
  .radio-group-container {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-bottom: ${({ theme: { token } }) => token.margin}px;
  }
  .radio-group-wrapper {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .select-table-number {
    width: 100%;
    margin-bottom: ${({ theme: { token } }) => token.margin}px;
  }
  .button-container {
    margin-top: ${({ theme: { token } }) => token.margin}px;
    justify-content: flex-end;
    width: 100%;
  }
`;

export const PageContainerForCreateNewDraftFallback = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: transparent;

  .content-section {
    text-align: center;
    max-width: 480px;
    width: 100%;
  }
  .title {
    font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
    margin-bottom: ${({ theme: { token } }) => token.marginSM}px;
  }
  .modal-subtitle {
    display: block;
    font-size: ${({ theme: { token } }) => token.fontSize}px;
    margin-bottom: ${({ theme: { token } }) => token.marginXS}px;
  }
  .filter-content {
    text-align: left;
    margin-bottom: ${({ theme: { token } }) => token.marginLG}px;
  }
  .full-width-space {
    width: 100%;
    direction: vertical;
  }
  .filter-condition-container {
    margin-bottom: ${({ theme: { token } }) => token.margin}px;
    display: flex;
    align-items: flex-start;
    gap: 8px;
  }
  .filter-condition-content {
    flex: 1;
  }
  .and-condition-container {
    display: flex;
    align-items: center;
    margin-bottom: ${({ theme: { token } }) => token.marginXS}px;
  }
  .and-label {
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
    margin-right: ${({ theme: { token } }) => token.marginSM}px;
    color: ${({ theme: { token } }) => token.colorText};
  }
  .full-width-select {
    width: 100%;
  }
  .compressor-width-select {
    width: 100%;
    margin-top: ${({ theme: { token } }) => token.marginSM}px;
  }
  .add-condition-button {
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    color: ${({ theme: { token } }) => token.colorPrimary};
    cursor: pointer;
    margin-top: ${({ theme: { token } }) => token.marginSM}px;

    &:hover {
      text-decoration: underline;
    }
  }
  .applied-filters-container {
    margin-bottom: ${({ theme: { token } }) => token.margin}px;
  }
  .applied-filters-label {
    margin-bottom: ${({ theme: { token } }) => token.marginSM}px;
    display: block;
  }
  .applied-filters-tag {
    background: ${({ theme: { token } }) => token.colorBgElevated};
    border: 1px solid ${({ theme: { token } }) => token.colorBorderSecondary};
    color: ${({ theme: { token } }) => token.colorPrimary};
    border-radius: 4px;
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    padding: ${({ theme: { token } }) => token.paddingXXS}px ${({ theme: { token } }) => token.paddingSM}px;
  }
  .button-row {
    display: flex;
    gap: 12px;
    margin-bottom: ${({ theme: { token } }) => token.marginLG}px;
    justify-content: center;
  }

  .select-for-create-new-draft-fallback {
    width: 70%;
    margin-bottom: ${({ theme: { token } }) => token.margin}px;
  }

  .base-fallback-label {
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    color: ${({ theme: { token } }) => token.colorText};
    margin-bottom: ${({ theme: { token } }) => token.marginSM}px;
  }

  .create-button-for-create-new-draft-fallback {
    &.ant-btn {
      background: ${({ theme: { token } }) => token.colorPrimary};
      border: none;
      color: white;
      font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
      height: 40px;
      width: 100%;
      border-radius: 6px;
    }
    &:hover,
    &:focus {
      background: ${({ theme: { token } }) => token.colorPrimaryHover};
      color: white;
    }
    &:disabled {
      background: ${({ theme: { token } }) => token.colorBgContainerDisabled};
      color: ${({ theme: { token } }) => token.colorTextDisabled};
    }
  }
`;

// FilterDropdown styled components
export const FilterDropdownContainer = styled.div`
  width: 300px;

  .filter-header {
    margin-bottom: ${({ theme: { token } }) => token.marginSM}px;
  }

  .filter-subtitle {
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    color: ${({ theme: { token } }) => token.colorText};
  }

  .filter-title {
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
    color: ${({ theme: { token } }) => token.colorText};
  }

  .filter-condition-container {
    margin-bottom: ${({ theme: { token } }) => token.margin}px;
    display: flex;
    align-items: flex-start;
    gap: 8px;
    color: ${({ theme: { token } }) => token.colorText};
  }

  .filter-condition-content {
    flex: 1;
  }

  .and-condition-container {
    display: flex;
    align-items: center;
    margin-bottom: ${({ theme: { token } }) => token.marginXS}px;
  }

  .and-label {
    margin-right: ${({ theme: { token } }) => token.marginSM}px;
    color: ${({ theme: { token } }) => token.colorTextLabel};
  }

  .full-width-select {
    width: 240px;
  }

  .compressor-width-select {
    width: 240px;
    margin-top: ${({ theme: { token } }) => token.marginSM}px;
  }

  .add-condition-button {
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    color: ${({ theme: { token } }) => token.colorPrimary};
    cursor: pointer;
  }

  .filter-actions-container {
    margin-top: ${({ theme: { token } }) => token.margin}px;
    justify-content: flex-end;
    width: 100%;
  }

  .base-fallback-label {
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    color: ${({ theme: { token } }) => token.colorText};
  }
`;

export const IgnoreFallbackCompressorsContainer = styled.div<{ $isReadOnly?: boolean }>`
  ${({ $isReadOnly }) => $isReadOnly && 'pointer-events: none; '}

  .label-container {
    margin-bottom: 8px;
    color: ${({ theme: { token } }) => token.colorText};
    display: flex;
    align-items: center;
    pointer-events: auto;
  }

  .info-icon {
    margin-left: ${({ theme: { token } }) => token.marginXS}px;
    cursor: pointer;
    color: ${({ theme: { token } }) => token.colorTextSecondary};
    pointer-events: auto;
  }
`;

export const TooltipContainer = styled.div`
  max-width: 300px;
  line-height: 1.5;

  .tooltip-paragraph {
    margin-bottom: ${({ theme: { token } }) => token.marginXS}px;
  }

  .tooltip-bullet-list {
    padding-left: ${({ theme: { token } }) => token.paddingMD}px;
    margin-bottom: ${({ theme: { token } }) => token.marginXS}px;
  }

  .tooltip-bullet-item {
    margin-bottom: ${({ theme: { token } }) => token.marginXXS}px;
    display: flex;
  }

  .tooltip-bullet {
    margin-right: ${({ theme: { token } }) => token.marginXS}px;
  }
`;
